export default function(context) {
  const userAgent = process.server
    ? context.req.headers['user-agent']
    : navigator.userAgent
  ;

  context.userAgent = userAgent;
  context.isIosWebView = /(?=.*MyMottiv)(?=.*WebView)/.test(userAgent);
};
